(function($) {
	
	/*
	 * General Google Analytics Tracking
	 * Some of trackings could not be found here as they 
	 * are inside of their specific classes/handlers.
	 * 
	 * Here is an exception list:
	 * 
	 * Soft Launch Bar events => Please see the soft-launch.js
	 * 
	 */
	
	/*
	 * Let's create our object and use it for track all events
	 */
	
	$(document).ready(function() {
		var gaTracker = null;
		
		if (typeof DbbGoogleAnalyticsTracker !== 'undefined') {
			gaTracker = new DbbGoogleAnalyticsTracker();
			
			// Categories
			var gaTrackingCategories = {};
			gaTrackingCategories['button'] = 'Button';
			gaTrackingCategories['breadcrumb'] = 'Breadcrumb';
			gaTrackingCategories['socialMedia'] = 'Social Media';
			gaTrackingCategories['faqSliders'] = 'FAQ Sliders';
			gaTrackingCategories['becomeAFranchiseeSliders'] = 'Franchisee Sliders';
			gaTrackingCategories['programSchedules'] = 'Program Schedules';
			gaTrackingCategories['forms'] = 'Forms';
			gaTrackingCategories['phone'] = 'Phone Number';
			gaTrackingCategories['email'] = 'Email';
			
			// Actions
			var gaTrackingActions = {};
			gaTrackingActions['click'] = 'Click';
			gaTrackingActions['submission'] = 'Submission';
			gaTrackingActions['view'] = 'View';
			gaTrackingActions['viewProgram'] = 'View Program';
			gaTrackingActions['viewLocation'] = 'View Location';
			gaTrackingActions['registerOnline'] = 'Register Online';
			gaTrackingActions['registerPdf'] = 'Register PDF';
			gaTrackingActions['registerEmail'] = 'Register Email';
			gaTrackingActions['registrationsPerSeason'] = 'Registrations Per Season';
			gaTrackingActions['registrationsPerAge'] = 'Registrations Per Age';
			gaTrackingActions['registrationsPerTime'] = 'Registrations Per Time';
			gaTrackingActions['registrationsPerIndoorOutdoor'] = 'Registrations Per Indoor/Outdoor';
			gaTrackingActions['registrationsPerParticipation'] = 'Registrations Per Participation';
			gaTrackingActions['registrationsPerProgramType'] = 'Registrations Per Program Type';
			gaTrackingActions['registrationsPerSport'] = 'Registrations Per Sport';
			gaTrackingActions['registrationsPerLocation'] = 'Registrations Per Location';
			gaTrackingActions['registrationsPerRegion'] = 'Registrations Per City';
			gaTrackingActions['registrationsPerState'] = 'Registrations Per Province/State';
			gaTrackingActions['applyForWaitList'] = 'Waitlist';
			gaTrackingActions['resetFilters'] = 'Reset Filters';
			gaTrackingActions['programsLoaded'] = 'Programs Loaded';
			gaTrackingActions['useDevicePosition'] = 'Use Device Postion';
			gaTrackingActions['searchLocations'] = 'Search Locations';
			gaTrackingActions['resetSearchLocation'] = 'Reset Search Location (Selected city)';
			gaTrackingActions['postalCodeSearch'] = '[Postal Code] Search Locations';
			gaTrackingActions['addressSearch'] = '[Address] Search Locations';
			gaTrackingActions['combinedSearch'] = '[Combination] Search Locations';
			gaTrackingActions['genericFilter'] = 'Filter';
			gaTrackingActions['filterChildAge'] = 'Filter (Child Age)';
			
			// Let's get it started
			
			
			/*
			=======================================================
				General (all pages)
			=======================================================
			*/
			// Register online button
			$('.navbar-header__register-btn').click(function(event) {
				gaTracker.trackEvent(gaTrackingCategories['button'], gaTrackingActions['click'], 'Register Online (Header)');
			});
			
			// Breadcrumb
			$('.breadcrumbs__link').click(function(event) {
				gaTracker.trackEvent(gaTrackingCategories['breadcrumb'], gaTrackingActions['click'], $(this).data('link-title'));
			});
			
			// Social Media on Footer
			$('.footer-social__link').click(function(event) {
				gaTracker.trackEvent(gaTrackingCategories['socialMedia'], gaTrackingActions['click'], $(this).data('social-media-name') + ' (Footer)');
			});
			
			// Phone Numbers
			$('body').on('click', 'a[href^="tel:"]', function(event) {
				gaTracker.trackEvent(gaTrackingCategories['phone'], gaTrackingActions['click'], $(this).attr('href').replace(/^tel\:/, ''));
			});
			
			// Email
			$('body').on('click', 'a[href^="mailto:"]', function(event) {
				var linkHref = $(this).attr('href');
				
				if (linkHref.indexOf('?') >= 0) {
					// It has parameters, let's remove them before tacking it
					linkHref = linkHref.replace(/^mailto\:(.*?)\?.*$/, '$1');
				}
				else {
					// It doesn't have parameters
					linkHref = linkHref.replace(/^mailto\:/, '');
				}
				
				gaTracker.trackEvent(gaTrackingCategories['email'], gaTrackingActions['click'], linkHref);
			});
			
			
			/*
			=======================================================
				Home
			=======================================================
			*/
			// Home page banner button
			$('.hero--home .hero__button').click(function(event) {
				gaTracker.trackEvent(gaTrackingCategories['button'], gaTrackingActions['click'], $(this).data('button-title') + ' (Home Banner)');
			});
			
			// Brick wall links
			$('.brick__link').click(function(event) {
				if ($(this).hasClass('brick__link--twitter')) {
					// It should count as a Social Media
					gaTracker.trackEvent(gaTrackingCategories['socialMedia'], gaTrackingActions['click'], $(this).data('social-media-name') + ' (Home Block)');
				}
				else {
					gaTracker.trackEvent(gaTrackingCategories['button'], gaTrackingActions['click'], $(this).data('button-title') + ' (Home Block)');
				}
			});
			
			
			
			/*
			=======================================================
				FAQ
			=======================================================
			*/
			// Sliders
			$('body.page-template-template-faq .slider').on('shown.bs.collapse', function() {
				gaTracker.trackEvent(gaTrackingCategories['faqSliders'], gaTrackingActions['view'], $(this).data('slider-title'));
			});
			
			/*
			=======================================================
				Become a Franchisee
			=======================================================
			*/
			// Sliders
			$('body.page-template-template-become-a-franchisee .slider').on('shown.bs.collapse', function() {
				gaTracker.trackEvent(gaTrackingCategories['becomeAFranchiseeSliders'], gaTrackingActions['view'], $(this).data('slider-title'));
			});
			
			/*
			=======================================================
				Program Schedules
			=======================================================
			*/
			if ($('body.page-template-template-program-schedules').length > 0) {
				// Just to avoid any invalid trackings
				
				var websiteFranchiseeSlug = $('#schedules-container').data('franchisee-slug'); 
				
				var regionFullName = $('#schedules-container').data('region-state') + ' - ' + $('#schedules-container').data('region-name');
				
				// View/Select a program
				$(document).on('sportballOnShownProgram', function(event) {
					var programElement = $(event.programHtmlTable);
					
					var gaEventLabel = websiteFranchiseeSlug + ' > ' + regionFullName;
					gaEventLabel += ' > ' + programElement.data('location-name') + ' > ' + programElement.data('program-name');
					gaEventLabel += ' > ' + programElement.data('program-date');
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['viewProgram'], gaEventLabel);
				});
				
				// Register Online//Offline button
				/*
				 * It's also included here the code to track registrations
				 * for specific seasons, sports, participations...
				 */
				$('#schedules-container').on('click', '.program__register-button', function(event) {
					var gaEventActionKey = 'registerOnline';
					
					if ($(this).hasClass('btn-disabled')) {
						gaEventActionKey = 'registerPdf';
					}
					
					var programElement = $(this).closest('table.program-table');
					
					var gaEventLabel = websiteFranchiseeSlug + ' > ' + regionFullName;
					gaEventLabel += ' > ' + programElement.data('location-name') + ' > ' + programElement.data('program-name');
					gaEventLabel += ' > ' + programElement.data('program-date');
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					
					// Now let's categorize the registration
					gaEventActionKeyPrefix = 'registrationsPer';
					
					// Season
					gaEventActionKey = gaEventActionKeyPrefix + 'Season';
					
					gaEventLabel = $(".schedules-nav").children('li.active').children('a').data('season-name');
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					
					// Age
					gaEventActionKey = gaEventActionKeyPrefix + 'Age';
					
					gaEventLabel = programElement.data('age');
					
					if (!gaEventLabel) {
						gaEventLabel = 'Undefined';
					}
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					
					// Time Period
					gaEventActionKey = gaEventActionKeyPrefix + 'Time';
					
					gaEventLabel = programElement.data('time-period');
					
					if (!gaEventLabel) {
						gaEventLabel = 'Undefined';
					}
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					
					// Indoor/Outdoor
					gaEventActionKey = gaEventActionKeyPrefix + 'IndoorOutdoor';
					
					gaEventLabel = programElement.data('program-indoor-outdoor');
					
					if (!gaEventLabel) {
						gaEventLabel = 'Undefined';
					}
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					
					// Participation
					gaEventActionKey = gaEventActionKeyPrefix + 'Participation';
					
					gaEventLabel = programElement.data('program-participation');
					
					if (!gaEventLabel) {
						gaEventLabel = 'Undefined';
					}
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					
					// Program Type
					gaEventActionKey = gaEventActionKeyPrefix + 'ProgramType';
					
					gaEventLabel = programElement.data('program-type');
					
					if (!gaEventLabel) {
						gaEventLabel = 'Undefined';
					}
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					
					// Sport
					gaEventActionKey = gaEventActionKeyPrefix + 'Sport';
					
					var sportsString = programElement.data('program-sports');
					
					/*
					 * We need to check each sport and then send each of them
					 */
					if (sportsString) {
						var sports = sportsString.split(';');
						
						for (var i = 0 ; i < sports.length ; i++) {
							if (!sports[i]) {
								continue;
							}
							
							gaEventLabel = sports[i];
							
							gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
						}
					}
					else {
						gaEventLabel = 'Undefined';
						
						gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					}
					
					// Location
					gaEventActionKey = gaEventActionKeyPrefix + 'Location';
					
					gaEventLabel = programElement.data('location-name');
					
					if (!gaEventLabel) {
						gaEventLabel = 'Undefined';
					}
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					
					// Region
					gaEventActionKey = gaEventActionKeyPrefix + 'Region';
					
					gaEventLabel = programElement.data('region');
					
					if (!gaEventLabel) {
						gaEventLabel = 'Undefined';
					}
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
					
					// State
					gaEventActionKey = gaEventActionKeyPrefix + 'State';
					
					gaEventLabel = programElement.data('state');
					
					if (!gaEventLabel) {
						gaEventLabel = 'Undefined';
					}
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
				});
				
				// Apply for Wait List
				$('#schedules-container').on('click', '.program__wait-list-button', function(event) {
					var programElement = $(this).closest('table.program-table');
					
					var gaEventLabel = websiteFranchiseeSlug + ' > ' + regionFullName;
					gaEventLabel += ' > ' + programElement.data('location-name') + ' > ' + programElement.data('program-name');
					gaEventLabel += ' > ' + programElement.data('program-date');
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['applyForWaitList'], gaEventLabel);
				});
				
				// Download registration form
				$('#schedules-container').on('click', '.program__download-registration-form', function(event) {
					var programElement = $(this).closest('table.program-table');
					
					var gaEventLabel = websiteFranchiseeSlug + ' > ' + regionFullName;
					gaEventLabel += ' > ' + programElement.data('location-name') + ' > ' + programElement.data('program-name');
					gaEventLabel += ' > ' + programElement.data('program-date');
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['registerPdf'], gaEventLabel);
				});
				
				// Email registration (Email us)
				$('#schedules-container').on('click', '.program__register-email', function(event) {
					var programElement = $(this).closest('table.program-table');
					
					var gaEventLabel = websiteFranchiseeSlug + ' > ' + regionFullName;
					gaEventLabel += ' > ' + programElement.data('location-name') + ' > ' + programElement.data('program-name');
					gaEventLabel += ' > ' + programElement.data('program-date');
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['registerEmail'], gaEventLabel);
				});
				
				
				// View location map modal
				$('#schedules-container').on('click', '.program-location__map-link', function(event) {
					var programElement = $(this).closest('table.program-table');
					
					var gaEventLabel = websiteFranchiseeSlug + ' > ' + regionFullName;
					gaEventLabel += ' > ' + programElement.data('location-name');
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['viewLocation'], gaEventLabel);
				});
				
				// Reset filters
				$('#schedules-container').on('click', '.schedules__reset-filters', function(event) {
					var matchingResultsElement = $(this).siblings('.schedules__matching-results');
					
					var gaEventLabel = matchingResultsElement.data('matching-programs') + ' of ' + matchingResultsElement.data('total-programs') + ' programs';
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['resetFilters'], gaEventLabel);
				});
				
				// On Page Load
				$(document).one('onProgramsDisplayed', function(event) {
					// We use the one as it shouldn't be triggered more than once, is for the page load
					var gaEventLabel = event.numbeOfShownPrograms + ' of ' + event.activatedSeason.numberOfTotalPrograms + ' programs';
					gaTracker.trackPageView();
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['programsLoaded'], gaEventLabel, event.numbeOfShownPrograms);					
				});
				
				// On Page Load (but when a season is changed)
				$(document).on('onSeasonChange', function(event) {
					// The trick here is to listen only once for the onProgramsDisplayed
					$(document).one('onProgramsDisplayed', function(event) {
						var gaEventLabel = event.numbeOfShownPrograms + ' of ' + event.activatedSeason.numberOfTotalPrograms + ' programs';
						
						gaTracker.trackPageView();
						
						gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['programsLoaded'], gaEventLabel, event.numbeOfShownPrograms);
					});
				});

				// On performing a search location
				var postalCodeRegExp = null;
				
				var combinedAddressRegExp = null;
				
				if (window.appConfig.currentCountryPostalCodeRegularExpression != null) {
					postalCodeRegExp = new RegExp('^' + window.appConfig.currentCountryPostalCodeRegularExpression + '$', 'g');
					
					combinedAddressRegExp = new RegExp(window.appConfig.currentCountryPostalCodeRegularExpression, 'g');
				}
				
				$(document).on('onLocationSearchRequest', function(event) {
					if (event.locationSearchValue != null) {
						var gaEventLabel = event.locationSearchValue;
						
						gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['searchLocations'], gaEventLabel);
						
						if (postalCodeRegExp != null) {
							var gaEventActionKey = 'addressSearch';
							
							if (postalCodeRegExp.test(event.locationSearchValue)) {
								gaEventActionKey = 'postalCodeSearch';
							}
							else if ((combinedAddressRegExp.test(event.locationSearchValue)) && (!postalCodeRegExp.test(event.locationSearchValue))) {
								gaEventActionKey = 'combinedSearch';
							}
							
							gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions[gaEventActionKey], gaEventLabel);
						}
					}
				});
				
				// On asking to use the device position
				$(document).on('onProgramsFilterUserDeviceLocationRequestSuccess', function(event) {
					$(document).one('onLocationSearchChange', function(locationSearchChangeEvent) {
						var gaEventLabel = (locationSearchChangeEvent.locationSearchNewValue ? locationSearchChangeEvent.locationSearchNewValue : '');
						
						gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['useDevicePosition'], gaEventLabel);
					});
				});
				
				// On reset to the selected city position
				$(document).on('onLocationSearchReset', function (event) {
					var gaEventLabel = '';
					gaEventLabel += event.centralRegionState;
					
					if (
						(gaEventLabel != '')
						&& ((event.centralRegionName) && (event.centralRegionName != ''))
					) {
						gaEventLabel += ' - ';
					}
					
					gaEventLabel += event.centralRegionName;
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['resetSearchLocation'], gaEventLabel);
				});
				
				// On age filter change
				$(document).on('onAgeFilterChange', function(event) {
					var gaEventLabel = null;
					
					var months = null;
					
					if (event.filterValue == 'all') {
						gaEventLabel = 'All Ages';
					}
					else if (event.filterValue < 24) {
						months = parseInt(event.filterValue);
						
						if (!isNaN(months)) {
							gaEventLabel = months + ' month' + (months != 1 ? 's' : '');  
						}
					}
					else {
						months = parseInt(event.filterValue);
						
						if (!isNaN(months)) {
							gaEventLabel = '';
							
							if (months % 12 != 0) {
								gaEventLabel = (months / 12.).toFixed(1);
							}
							else {
								gaEventLabel = months / 12;
							}
							
							gaEventLabel += ' year' + (months != 12 ? 's' : '');
						}
					}
					
					gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['filterChildAge'], gaEventLabel);
				});
				
				// On Week Day filter selected
				$(document).on('onWeekDayFilterSelected', function(event) {
					if (event.filterValue) {
						var gaEventAction = gaTrackingActions['genericFilter'] + ' (Day of the Week)';
						
						for (var i = 0 ; i < event.filterValue.length ; i++) {
							if (event.filterValue[i].checked) {
								var gaEventLabel = event.filterValue[i].name;
								
								gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaEventAction, gaEventLabel);
							}
						}
					}
				});
				
				// On Time Perido filter selectd
				$(document).on('onTimeFilterSelected', function(event) {
					if (event.filterValue) {
						var gaEventAction = gaTrackingActions['genericFilter'] + ' (Time)';
						
						for(var i = 0 ; i < event.filterValue.length ; i++) {
							if (event.filterValue[i].checked) {
								var gaEventValue = event.filterValue[i].name;
								
								gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaEventAction, gaEventLabel);
							}
						}
					}
				});
				
				/*
				 * On Thriva option base filter change
				 * Thriva option bases could be:
				 * Participations
				 * Program Types
				 * Sports
				 */
				$(document).on('onThrivaOptionBaseFilterChange', function(event) {
					if (event.filterValue.checked) {
						var gaEventLabel = event.filterValue.name;
						
						var gaEventActionSuffix = '(';
						
						switch (event.filterValue.type) {
							case 'participation':
								gaEventActionSuffix += 'Participation)';
								
								break;
							case 'programType':
								gaEventActionSuffix += 'Program Type)';
								
								break;
							case 'sport':
								gaEventActionSuffix += 'Sport)';
								
								break;
							default:
								gaEventActionSuffix += 'Thriva Option: ' + event.filterValue.type + ')';
								
								break;
						}
						
						gaTracker.trackEvent(gaTrackingCategories['programSchedules'], gaTrackingActions['genericFilter'] + ' ' + gaEventActionSuffix, gaEventLabel);
					}
				});
			}
			
			/*
			=======================================================
				About Programs
			=======================================================
			*/
			// Sport/Program Type/Participation modal
			$('body.page-template-template-about-programs .sticker-list__item-link').click(function(event) {
				var fullLink = $(this).attr('href');
				
				var linkToPageView = '';
				
				if (fullLink.indexOf(window.appConfig.websiteBaseUrl) == 0) {
					linkToPageView = fullLink.replace(window.appConfig.websiteBaseUrl, '');
					
					gaTracker.trackPageView(linkToPageView);
				}
			});
			
			/*
			=======================================================
				Meet Our Team
			=======================================================
			*/
			// Team member modal
			$('body.page-template-template-meet-our-team .sticker-list__item-link').click(function(event) {
				linkToPageView = window.appConfig.pagePathname + '/' + $(this).data('member-slug');
				
				gaTracker.trackPageView(linkToPageView);
			});
			
			/*
			=======================================================
				Gravity Forms
			=======================================================
			*/
			// Track when a form is submitted
			$(document).on('gform_confirmation_loaded', function(event, formId, formName) {
				var gaEventLabel = formName;
				
				gaTracker.trackEvent(gaTrackingCategories['forms'], gaTrackingActions['submission'], gaEventLabel);
			});
			
			if (typeof window['formSubmissionSuccess'] !== 'undefined') {
				// It has a form submission, so let's send the event as well
				var gaEventLabel = window.formSubmissionSuccess.name;
				
				gaTracker.trackEvent(gaTrackingCategories['forms'], gaTrackingActions['submission'], gaEventLabel);
			}
		}
	});
	
	
})(window.jQuery);